import React from 'react';
import Contact from '../../components/Contact/Contact';
import './ContactPage.scss';

interface ContactPageProps {
  menuOpen: boolean;
}

const ContactPage: React.FC<ContactPageProps> = ({ menuOpen }) => {
  return (
    <div className={`contact-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="contact-page__background"></div>
      <div className="contact-page__hero">
        <div className="contact-page__content">
          <h1 className="contact-page__title">ASK FOR A BROCHURE / CONTACT</h1>
          <div className="contact-page__form-wrapper">
            <Contact />
          </div>
          
          <div className="contact-page__info">
            <div className="info-grid">
              <div className="info-card">
                <h3>Our Location</h3>
                <p>5a Underhill Street</p>
                <p>Bridgnorth</p>
                <p>WV16 5BB</p>
              </div>
              
              <div className="info-card">
                <h3>Contact Details</h3>
                <p>Email: hello@stagedoorweddings.co.uk</p>
                <p>Phone: +44 7735 138653</p>
              </div>
              
              <div className="info-card">
                <h3>Working Hours</h3>
                <p>Monday - Friday: 9am - 6pm</p>
                <p>Weekends: By appointment</p>
              </div>
            </div>
          </div>
          
          <div className="contact-page__map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.8076112462166!2d-2.4207884233283297!3d52.53562997436752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48707e0e4a4b89c7%3A0x9b4b5d6f7b2d3e3a!2s5a%20Underhill%20St%2C%20Bridgnorth%20WV16%205BB!5e0!3m2!1sen!2suk!4v1695056789012!5m2!1sen!2suk" 
              width="100%" 
              height="300" 
              style={{ border: 0 }} 
              allowFullScreen={true} 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Stage Door Weddings Office Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
